import { Grid } from "grommet";
import { CustomCard } from "../components/competetive/CustomCard";

export const StorageDashboardGrid = ({ applicationsList, history, size, ...rest }) => {
    const applications = Array.from(applicationsList.data)
        .sort((a, b) => (a.order > b.order ? 1 : a.order < b.order ? -1 : 0))
        .map((group) => (
            <CustomCard
                key={group.id}
                title={group.application_name}
                description={group.application_desc}
                onClickHandler={() => {
                    history.push(`/storage/${group.id}`);
                }}
            />
        ));
    return (
        <Grid
            columns={size === 'xlarge' || size === 'large' ? "20%" : '50%'} gap={"medium"}
            rows={[["auto", "full"]]}
            {...rest}
            pad='medium'
            fill
        >
            <CustomCard title={"Competitive"} description={"Deep Competitive Solutions, Competitive Overview ..."} onClickHandler={() => { history.push('/competitor') }} />
            {applications}
        </Grid>
    );
};